exports.APP_VERSION = "1.8.0.10"; // DO NOT TOUCH
